import React from 'react';
import PhonicsAtoZ from './PhonicsAtoZ';
import letterDataDd from './phonics/phonics_data_dd';

/**
 * Phonics Letter Dd 页面
 * 复用 PhonicsAtoZ 通用组件，只传入 Dd 数据
 */
function PhonicsDd() {
  return <PhonicsAtoZ letterData={letterDataDd} />;
}

export default PhonicsDd;
